import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
  },
  getters: {
    loading: state => state.loading,
  },
  mutations: {
    alterloading: (state, val) => state.loading = val,
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js